<template>
  <div class="home container">
    <div class="row">
        <div class="col-md-10">
          <router-link  class="btn draw-border back" :to="{ name: 'Home' }">
              Back
          </router-link>
        </div>
    </div>
    <div class="row ">
      <div class="col-md-12 ">
        <div class="image-wrapper carousel-wrapper">
          <carousel :responsive="responsive">
              <img src="@/assets/gallery/img1.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img2.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img3.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img4.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img5.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img6.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img7.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img8.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img9.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img10.jpg" alt="Burwood Brickworks">
              <img src="@/assets/gallery/img11.jpg" alt="Burwood Brickworks">
          </carousel>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import carousel from 'vue-owl-carousel'


export default {
  name: 'Gallery',
  components: {
    carousel
  },
  data() {
    return {
      responsive: {
        0:{
            items:1,
            margin: 0,
            dots: true,
            nav: false,
        },
        500:{
            items:1,
            margin: 0,
            dots: true,
            nav: false,
        },
        1030:{
            items:1,
            margin: 0,
            dots: true,
            nav: false,
        }
      }
    }
  },
  created() {

  },
}
</script>

<style lang="scss">
  .hero-wrapper {
    margin-bottom: 20px;
  }
  .carousel-wrapper {
    width:calc(100vw - 20px);
    margin:0 auto;
  }
  // Small devices (landscape phones, 576px and up)
  @media (min-width: 576px) {

  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {
    .carousel-wrapper {
      width:100%;
    }
  }

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) {

  }

  // Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {

  }
</style>
